import {
  SearchGroupRatesByPropertyIdsResponse,
  SearchGroupRatesByPropertyIdsResponseDtt,
  searchGroupRatesByPropertyIdsQuery,
  searchGroupRatesByPropertyIdsDttQuery,
} from '@marriott/mi-groups-graphql';
import { useLazyQueryTransformer } from '../../hooks';

type SearchGroupRatesByPropertyIds = {
  searchGroupRatesByPropertyIds: SearchGroupRatesByPropertyIdsResponse;
};

//DTT Type
type SearchGroupRatesByPropertyIdsDtt = {
  search: { groupRates: { searchByPropertyId: SearchGroupRatesByPropertyIdsResponseDtt } };
};

export const useSearchGroupRatesByPropertyIds = () => {
  return useLazyQueryTransformer<SearchGroupRatesByPropertyIds, SearchGroupRatesByPropertyIdsDtt>({
    currentQuery: searchGroupRatesByPropertyIdsQuery,
    dttQuery: searchGroupRatesByPropertyIdsDttQuery,
    onTransform: data => {
      const { edges } = data?.searchGroupRatesByPropertyIds || {};

      return {
        search: {
          groupRates: {
            searchByPropertyId: {
              edges: edges.map(edge => ({
                node: { ...edge.node },
                groupRate: {
                  isBookingAllowed: edge?.groupRate?.availability?.code === '1',
                  eventSpaceRates:
                    edge?.groupRate?.eventSpaceRates?.map(eventSpace => ({
                      id: eventSpace.id,
                      name: eventSpace.name,
                      amount: {
                        amount: eventSpace.amount.origin.value,
                        currency: eventSpace.amount.origin.currency,
                        decimalPoint: eventSpace.amount.origin.valueDecimalPoint,
                      },
                    })) || [],
                  roomRates:
                    edge?.groupRate?.roomRates?.map(roomRate => ({
                      amount: {
                        amount: roomRate.amount.origin.value,
                        currency: roomRate.amount.origin.currency,
                        decimalPoint: roomRate.amount.origin.valueDecimalPoint,
                      },
                    })) || [],
                },
              })),
            },
          },
        },
      };
    },
    selectDttFlag: s => s.isDttSwpGroupsEnabled || s.isSwp,
  });
};
